import { render, staticRenderFns } from "./messageTransmission.vue?vue&type=template&id=dea23b14&scoped=true&"
import script from "./messageTransmission.vue?vue&type=script&lang=js&"
export * from "./messageTransmission.vue?vue&type=script&lang=js&"
import style0 from "./messageTransmission.vue?vue&type=style&index=0&id=dea23b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea23b14",
  null
  
)

export default component.exports